import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { SessionStorageService } from 'ngx-webstorage';
import { environment } from 'environments/environment';
import { IAction, PermissionModel } from './permission.model';
import { UserModel } from './user.model';
import { Observable, Subject, throwError, of } from 'rxjs';
import {retry, catchError, timeout, map, tap} from 'rxjs/operators';
// import { BrandModel } from './brand.model';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  private _user: UserModel;

  private get user(): UserModel {
    if (this._user) {
      return this._user;
    }

    const user = this.sessionStorageService.retrieve('user') as UserModel;
    if (user) {
      return plainToClass(UserModel, user);
    }

    return undefined;
  }

  private set user(value: UserModel) {
    this.sessionStorageService.store('user', value);
    this._user = value;
  }

  private userSubject = new Subject<UserModel>();

  roleId = 'userManteiner';

  constructor(
    private httpClient: HttpClient,
    private sessionStorageService: SessionStorageService) {
  }

  
  fetchUser(email: string, country?: string): Observable<UserModel> {
    if (!!this.user?.email && this.user.email.toLowerCase() === email.toLowerCase() && !country) {
      return of(this.user);
      
    } else {
      let url = `${ environment.get_user }${ email.toLocaleLowerCase() }`;
      !!country && (url += `/${ country }`);

      return this.httpClient.get<UserModel>(url).pipe(
        map(user => {
          if (user.lstCountryStores && user.lstCountryStores[0] && user.lstCountryStores[0].lstStores) {
            user.lstCountryStores[0].lstStores = user.lstCountryStores[0].lstStores.sort((a, b) =>
              +a.identificationNumber - +b.identificationNumber
            );
          }

          if (user.lstCountryStores[0].lstStores.length < 1) {
            throw (new Error('sin tiendas'));
          }

          this.user = plainToClass(UserModel, user);
          this.userSubject.next(this.user);
          return this.user;
        }),
        tap(console.log),
        timeout(9000),
        retry(2),
        catchError(throwError)
      );
    }
  }

  
  async changeCountry(country: string): Promise<UserModel> {
    return this.fetchUser(this.user.email, country.toUpperCase()).toPromise();
  }

  getUser(): Observable<UserModel> {
    if (this.user) {
      return of(this.user);
    }
    return this.userSubject.asObservable();
  }

  get userName(): string {
    return this.user ? this.user.email : '';
  }

  get email(): string {
    return this.user.email;
  }

  get buc(): boolean {
    return this.user.bucEnableCountry;
  }

  get channelBuc(): string {
    return this.user.bucEnableChannel;
  }

  deleteUser(): void {
    this.sessionStorageService.clear('user');
  }
  
  getPermissionsForModule(moduleName: string): PermissionModel {
    if (!this.user) {
      return undefined;
    }

    let permission: PermissionModel;

    this.user.lstRoles.forEach(role => {
      const p = role.lstPermissions.find(item => item.name === moduleName);

      if (!permission) {
        permission = p;
      } else {
        permission.action.read = permission.action.read && p.action.read;
        permission.action.create = permission.action.create && p.action.create;
        permission.action.delete = permission.action.delete && p.action.delete;
        permission.action.edit = permission.action.edit && p.action.edit;
      }
    });

    return permission;
  }


  getActionsForModule(moduleName: string): IAction {
    const permission = this.getPermissionsForModule(moduleName);
    return permission ? permission.action : undefined;
  }

  // changeRole(roleId: string): Observable<UserModel> {
  // 	this.roleId = roleId;
  // 	this.user.next(null);
  // 	return this.getUser();
  // }

  private TEST_getUser() {
    return this.httpClient.get('api/' + this.roleId)
    .pipe(
      map(r => this.user = plainToClass(UserModel, r))
    );
  }
}
